export default {
  init() {
    // JavaScript to be fired on all pages

    // Collapse ////////////////////////////////////////////////////////
    // Initialized collapse elements
    setTimeout(() => {
      $('.collapse').each(function () {
        var elm = $(this);

        if (
          elm.hasClass('show') &&
          elm.prev('.collapse-toggle').hasClass('active')
        ) {
          elm.show();
        }
      });
    }, 500);

    // When collapse toggle is clicked
    $('body').on('click', '.collapse-toggle', function () {
      var toggle = $(this);
      var group = toggle.data('group');
      var target = $(toggle.data('target'));
      var limit = toggle.data('limit');

      if (limit === 'any') {
        target.slideToggle(400);
        toggle.toggleClass('active');
      } else {
        if (toggle.hasClass('active')) {
          toggle.removeClass('active');
          target.slideUp(400);
        } else {
          $(group + '.collapse-toggle').removeClass('active');
          toggle.addClass('active');
          $(group + '.collapse').slideUp(400);
          target.slideDown(400);
        }
      }

      // var slickTarget = toggle.data('slick');
      // if (slickTarget !== undefined) {
      //   var slideIndex = toggle.data('goto');
      //   $(slickTarget).slick('slickGoTo', parseInt(slideIndex));
      // }

      var autoscroll = toggle.data('autoscroll');

      if (autoscroll) {
        setTimeout(() => {
          $('html,body').animate(
            {
              scrollTop: toggle.offset().top,
            },
            1000
          );
        }, 500);
      }
    });
    // Collapse //////////////////////////////////////////////////////// END

    /*
     * Mobile Menu Toggle - Start
     */
    $('body').on('click', '#mobimenu-toggle', function () {
      const mobimenuCheckbox = $(this).children('input');
      const mobimenuContainer = $('#mobimenu-container');
      const mobimenuContent = $('.mobile-nav');

      if (mobimenuCheckbox.prop('checked')) {
        mobimenuContainer.slideDown(400);

        setTimeout(() => {
          mobimenuContent.addClass('appear');
        }, 600);
        return;
      }

      mobimenuContent.removeClass('appear');

      setTimeout(() => {
        mobimenuContainer.slideUp(400);
      }, 300);
    });

    // Sub menu closes menu when clicked
    $('body').on('click', '.sub-menu > li > a', function () {
      const mobimenuCheckbox = $('#mobimenu-toggle').children('input');
      const mobimenuContainer = $('#mobimenu-container');
      const mobimenuContent = $('.mobile-nav');

      if (mobimenuCheckbox.prop('checked')) {
        setTimeout(() => {
          mobimenuContainer.slideUp(400);
        }, 300);

        mobimenuCheckbox.prop('checked', false);
        mobimenuContent.removeClass('appear');
      }
    });
    /*
     * Mobile Menu Toggle - End
     */
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js